import ActionTypes from './action-types';

export function waitlistReducer(state = {}, action) {
  switch(action.type) {
    case ActionTypes.AddToWaitlistRequested: {
      return Object.assign({}, state, {
        inProgress: true,
        error: '',
        success: '',
        waitlistSuccess: false
      });
    }
    case ActionTypes.AddToWaitlistRejected: {
      return Object.assign({}, state, {
        inProgress: false,
        error: 'Error in adding to waitlist.',
        waitlistSuccess: false
      });
    }
    case ActionTypes.AddToWaitlistFulfilled: {
      return Object.assign({}, state, {
        inProgress: false,
        success: 'Added to waitlist.',
        waitlistSuccess: true,
        email: action.email,
      });
    }
    case ActionTypes.WaitlistCountFetched: {
      return Object.assign({}, state, {
        waitlistCount: action.waitlistCount
      });
    }
    case ActionTypes.FetchUserCount: {
      return Object.assign({}, state, {
        waitlistCount: action.response
      });
    }
    case ActionTypes.WaitlistUserCountAddFailed: {
      return Object.assign({}, state, {
        error: action.error
      });
    }
    case ActionTypes.WaitlistUserCountAddSuccessful: {
      return Object.assign({}, state, {
        response: action.response
      });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/waitlist/reducer.js